import { parse as qsParse } from "querystring";
export { stringify } from "querystring";

export const parse = (search: string) => {
    const str = search[0] === "?" ? search.slice(1) : search;
    return qsParse(str);
};
